
/**
 * @param {number} num
 */
export function toHexStr(num) {
  return `0x${num.toString(16)}`
}